import { memo } from 'react';
import {
  Guidingtip,
  GUIDINGTIP_ALIGNS,
  GUIDINGTIP_POSITIONS,
  GUIDINGTIP_THEMES,
  useOnboarding,
} from '@wg/wows-react-uikit';

import { ONBOARDING_GUIDES, ONBOARDING_GUIDES_CONFIG } from '~/const/onboarding';
import dwhExport, { DWH_EVENTS } from '~/dwhExport';
import { t } from '~/helpers/localization';
import { useAppSelector } from '~/store/';
import { isClanMemberSelector } from '~/store/selectors/currentAccountSelector';

import Back from '~/Components/UIKit/Back/Back';

import styles from './NavMenuBack.module.scss';

const NavMenuBackClanHub = () => {
  const isClanMember = useAppSelector(isClanMemberSelector);
  const { isCurrentStepCompleted } = useOnboarding({
    stepName: ONBOARDING_GUIDES.CLANHUB_NAV_RETURN_TO_CLANHUB,
  });

  const handleClick = () => {
    dwhExport.push(DWH_EVENTS.CLANHUB.BACK_TO_CLANHUB_CLICK);
  };

  const content = <Back shouldGoToRoot onClick={handleClick} />;

  if (!isClanMember || isCurrentStepCompleted) {
    return content;
  }

  return (
    <Guidingtip
      className={styles.hubTilesSmall}
      name={ONBOARDING_GUIDES_CONFIG.CLANHUB_NAV_RETURN_TO_CLANHUB.name}
      header={ONBOARDING_GUIDES_CONFIG.CLANHUB_NAV_RETURN_TO_CLANHUB.header}
      content={ONBOARDING_GUIDES_CONFIG.CLANHUB_NAV_RETURN_TO_CLANHUB.content}
      position={GUIDINGTIP_POSITIONS.RIGHT}
      align={GUIDINGTIP_ALIGNS.CENTER}
      theme={GUIDINGTIP_THEMES.CLIENT}
      delay={1000}
      withBeacon
      completeOnClick
      isActionBtnVisible
      actionBtnText={t('Закрыть')}
    >
      {content}
    </Guidingtip>
  );
};

export default memo(NavMenuBackClanHub);
